module.exports = __webpack_public_path__ + "static/media/Article1.64c32fd4.jpg";